module.exports = __webpack_public_path__ + "img/why_has_nobody_told_me.357611ed.jpg";